module.exports = __webpack_public_path__ + "img/aircon.9531b2c0.png";